import React, { Suspense } from "react";
import { ArrowRight, Sparkles, Users, Clock } from "lucide-react";
import { Logo3D } from "./Logo3D";

export const Hero = ({ onViewExperiences }) => {
  return (
    <section className="min-h-screen flex items-center relative overflow-hidden pt-20 !rounded-none bg-hero-gradient grain-overlay">
      <div className="flex flex-col lg:flex-row w-full max-w-[1400px] mx-auto px-5 md:px-[7.6923%] items-center">
        {/* 3D Logo */}
        <div className="w-full lg:flex-1 flex justify-center items-center relative order-first lg:order-last">
          <div className="w-[340px] h-[340px] sm:w-[420px] sm:h-[420px] lg:w-[600px] lg:h-[600px] overflow-visible relative">
            <Logo3D />
          </div>
        </div>

        {/* Left Content */}
        <div className="flex-1 z-10 pb-16 lg:py-0 order-last lg:order-first">
          <div
            className="inline-flex items-center gap-2 px-4 py-2 mb-8 animate-fade-in"
            style={{ border: "1px solid var(--np-border)" }}
          >
            <Sparkles size={14} style={{ color: "var(--np-accent)" }} />
            <span className="text-sm tracking-wider uppercase" style={{ color: "var(--np-text-secondary)" }}>
              Network Playground
            </span>
          </div>

          <h1
            className="text-[clamp(36px,5.5vw,66px)] font-semibold leading-[1.1] tracking-tight mb-6 animate-fade-in-up"
            style={{ color: "var(--np-text)" }}
          >
            Experiences
            <br />
            <span style={{ color: "var(--np-accent)" }}>Worth Having</span>
          </h1>

          <p
            className="text-xl mb-10 max-w-[480px] animate-fade-in-up"
            style={{ animationDelay: "100ms", color: "var(--np-text-secondary)" }}
          >
            Discover a curated collection of cultural events, musical evenings, and artistic gatherings designed for the discerning soul.
          </p>

          <div className="flex flex-wrap gap-4 mb-12 animate-fade-in-up" style={{ animationDelay: "200ms" }}>
            <button
              onClick={onViewExperiences}
              className="inline-flex items-center transition-all duration-500 font-medium text-lg px-8 py-4 gap-3 rounded-full"
              style={{ background: "var(--np-cta)", color: "var(--np-cta-text)" }}
            >
              View Experiences
              <ArrowRight size={20} />
            </button>
            <a
              href="https://wa.me/916363323202"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center transition-all duration-500 font-medium text-lg px-8 py-4 gap-3 rounded-full"
              style={{
                background: "var(--np-elevated)",
                color: "var(--np-text)",
                border: "1px solid var(--np-border)",
              }}
            >
              WhatsApp Us
            </a>
          </div>

          <div
            className="flex flex-wrap items-center gap-6 text-base animate-fade-in-up"
            style={{ animationDelay: "300ms", color: "var(--np-text-muted)" }}
          >
            <span className="flex items-center gap-2">
              <Sparkles size={16} style={{ color: "var(--np-accent)" }} /> Curated
            </span>
            <span className="w-px h-4" style={{ background: "var(--np-border-strong)" }} />
            <span className="flex items-center gap-2">
              <Users size={16} style={{ color: "var(--np-accent)" }} /> Limited Seats
            </span>
            <span className="w-px h-4" style={{ background: "var(--np-border-strong)" }} />
            <span className="flex items-center gap-2">
              <Clock size={16} style={{ color: "var(--np-accent)" }} /> Instant Confirmation
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
